/*
 * @Author: miaoqing6
 * @Date: 2025-03-03 16:21:00
 * @LastEditors: miaoqing6
 * @Date: 2025-03-03 16:21:00
 * @Description: file content
 */
import lodash from 'lodash';
import { BindAll } from 'lodash-decorators';
import { EnumAPI } from '../../apis';
import { AjaxBasics } from '../../helpers';
import { BasesController } from '../bases';

@BindAll()
export class PriceQuotationController<T = any> extends BasesController<T> {
  constructor() {
    super();
    this.reset({
      dataKey: 'quotationCode',
      infinite: true,
      pagination: EnumAPI.businessPriceQuotationList_search,
      paginationParams: {
        currentKey: 'pageNo',
        pageSizeKey: 'pageSize',
        response: {
          total: 'total',
          dataSource: 'records',
          valueGetter: this.valueGetter,
        },
      },
    });
  }
  valueGetter(res) {
    // const dataSource = lodash.map(lodash.get(res, 'records'), (item) => {
    //   const status = item.status != 8 ? item.status : item.reviewBeforeStatus;
    //   return lodash.assign(item, {
    //     _status: lodash.get(this.statusEnum, status),
    //   });
    // });

    const dataSource = lodash.get(res, 'records').map((item) => {
      const perItem = [];
      // perItem.push({
      //   label: item.quotationCode,
      //   value: item.statusDesc,
      //   isTitle: true,
      // });
      perItem.push({
        label: '报价单编号',
        value: item.quotationCode,
        isShow: false,
      });
      perItem.push({
        label: '状态描述',
        value: item.statusDesc,
        isShow: false,
      });
      perItem.push({ label: '状态', value: item.status, isShow: false });

      perItem.push({ label: '经销商编号', value: item.providerCode });
      perItem.push({ label: '经销商名称', value: item.providerName });
      perItem.push({
        label: '经销商联系人',
        value: item.providerContactPerson,
      });
      perItem.push({ label: '联系电话', value: item.providerContactPhone });
      perItem.push({ label: '报价金额', value: item.totalMoney });
      perItem.push({ label: '有效期', value: item.validTime });
      perItem.push({ label: '专属顾问', value: item.salesName });
      return perItem;
    });
    const total = lodash.get(res, 'total');
    return {
      dataSource,
      total,
    };
  }
  /**
   * @des 状态枚举
   */
  statusEnum = {
    '0': '草稿',
    '1': '已提交',
    '2': '跟进中',
    '3': '持续跟进',
    '4': '已关闭',
    '5': '已提交bidding',
    '6': '已生成报价单',
    '7': '已转订单',
  };

  /**
   * @des 复制商机
   */
  async onBusinessCopyBus(body) {
    return await AjaxBasics.request({
      ...EnumAPI.business_copyBus,
      body,
    });
  }

  /**
   * @des 获取报价单详情
   */
  async getPriceQuotationDetail(body) {
    return await AjaxBasics.request({
      ...EnumAPI.business_priceQuotationDetail,
      body,
    });
  }
}
